import { MessageDescriptor } from 'react-intl';
import { publishMessages } from '../publish-messages';

/** API keys that map to a user-facing intl message (checked on `error` and `errorCode`). */
const KNOWN_UPLOAD_ERROR_MESSAGES: Record<string, MessageDescriptor> = {
  youtube_reconnect_required: publishMessages.youtubeReconnectRequired,
};

/**
 * Resolves a known social-upload API error key to its intl message descriptor.
 * Returns undefined when the error should be shown as the raw API string.
 */
export function resolveUploadErrorMessage(
  error?: string,
  errorCode?: string,
): MessageDescriptor | undefined {
  return (
    (errorCode && KNOWN_UPLOAD_ERROR_MESSAGES[errorCode]) ||
    (error && KNOWN_UPLOAD_ERROR_MESSAGES[error]) ||
    undefined
  );
}
